import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import junk from '../../json/junk-removal-data.json'

const junkServiceData = {
  name: 'Junk Removal Services',
  description:
    'Efficient, eco-friendly junk removal for homes and businesses nationwide. Dimension hauls furniture, mattresses, appliances, electronics, and full cleanouts, with volume-based pricing and landfill diversion.',
  serviceType: 'Junk Removal',
  url: 'https://getdimension.com/junk-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Furniture Removal' },
    { name: 'Mattress Removal' },
    { name: 'Appliance Removal' },
    { name: 'TV and Electronics Removal' },
    { name: 'Full-House and Office Cleanouts' },
  ],
}

const junkFAQData = {
  questions: junk.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function JunkRemoval() {
  return (
    <>
      <Head>
        <title>Junk Removal Services | Dimension</title>
        <meta
          name="description"
          content="Efficient, eco-friendly junk removal for homes and businesses nationwide. Dimension hauls furniture, appliances, and full cleanouts with volume-based pricing from around $79."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/junk-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={junkServiceData} />
        <SchemaMarkup type="FAQPage" data={junkFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={junk.pitch.heading}
          material={junk.pitch.material}
          pitchText={junk.pitch.pitchText}
          ctaLink={junk.pitch.ctaLink}
          ctaText={junk.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...junk.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...junk.benefits} />
        <Approach {...junk.approach} />
        <FAQ {...junk.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Convenient removal of sofas, chairs, desks, and bulky furniture, with donation and recycling first.',
            },
            {
              label: 'Mattress Removal',
              href: '/mattress-removal',
              description:
                'Cheap mattress and bed-set disposal with recycling of steel, foam, and fiber.',
            },
            {
              label: 'Appliance Removal',
              href: '/appliance-removal',
              description:
                'Pickup and metal recycling of refrigerators, washers, ovens, and other old appliances.',
            },
            {
              label: 'TV and Electronics Removal',
              href: '/tv-electronics-removal',
              description:
                'Certified e-waste recycling for old TVs, monitors, computers, and electronics.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default JunkRemoval
